export const EMAIL_EXCLUDED_MODULE_FIELDS = [
  'schedule'
];

export const EMAIL_EXCLUDED_MODULE_FIELD_TYPES = [
  'custom_form_component',
];

export const EMAIL_RELATED_MODULE_CONTENT_USABLE_FIELDS = {
  'customers': [
    'name',
    'first_name',
    'last_name',
    'supplier_number',
    'customer_number',
    'address',
    'phone',
    'email_address',
    'id'
  ],
  'customer_invoices': [
    'customer_id',
    'site_id',
    'job_id',
    'contact_id',
    'invoice_number',
    'accounting_last_updated_id',
    'recurring_invoice_id',
  ],

  'sites': [
    'name',
    'site_number',
    'text',
    'email_address',
    'id'
  ],
  'contacts': [
    'first_name',
    'last_name',
    'phone',
    'address',
    'email_address',
    'id'
  ],
  'jobs': [
    ['job_number', 'number'],
  ],
  'asset_types': [
    'name',
    'asset_type_id',
  ],
  'departments': [
    ['department_name', 'text', 'name'],
    'id',
  ],
  'assets': [
    'name',
    'serial_number',
    'asset_id',
    'asset_group_id',
    'asset_type_id',
    'accounting_last_updated_id',
    'customer_id',
    'department_id',
    'parent_asset_id',
    'walk_order',
    'id'
  ],
  'asset_groups': [
    'name',
    'asset_group_id'
  ],
  'users': [
    'name',
    'first_name',
    'last_name',
    'email_address',
    'phone',
    'id'
  ],
  'opportunities': [
    ['opportunity_number', 'number'],
  ],
  'purchase_orders': [
    ['po_number', 'number'],

  ],
};

export const EMAIL_RELATED_MODULE_CONTENT_USABLE_FIELD_ALIASES = {
  'opportunities': 'quote',
  'customers': {
    for: [
      'supplier_invoices',
      'purchase_orders',
    ],
    alias: 'supplier',
  },
  'users': 'assigned_user',
};

export const EMAIL_COMPARISON_EXCLUDED_FIELDS = [
  'recurring_invoice_id',
  'address',
  'create_supplier_invoice_email_address',
  'create_job_email_address',
];

export const EMAIL_PER_MODULE_EXCLUDED_COMPARISON_FIELDS = {
  'supplier_invoices': [
    'purchasing_notes',
  ],
  'jobs': [
    'customer_notes',
  ],
  'opportunities': [
    'customer_notes',
  ],
};

export const EMAIL_PER_MODULE_EXCLUDED_COMPARISON_FIELD_TYPES = {
  'assets': [
    'asset_name',
    'asset_serial_number',
    'asset_accounting_last_updated_id',
    'asset_customer_id',
    'asset_department_id',
    'asset_parent_asset_id',
    'asset_variant',
    'asset_walk_order',
    'asset_id',
    'actual_faults',
    'hierarchical_view',
    'email_address'
  ],
  'customer_invoices': [
    'enable_group_by',
    'email_address',
  ],
  'supplier_invoices': [
    'email_address',
  ],
  'purchase_orders': [
    'email_address',
    'site_primary_tenant_contact_role',
  ],
  'jobs': [
    'email_address',
    'site_primary_tenant_contact_role',
  ]
};